import useSWR from "swr";
import useSWRInfinite from "swr/infinite";

function fetcher(url: string) {
  return (
    fetch(url)
      // Reject if the response is not OK
      .then((r) => (r.ok ? r.json() : Promise.reject(r)))
  );
}

export default function useData<T>(
  path: string | (() => string | undefined | null)
) {
  const { data, error, mutate, isValidating } = useSWR<T>(path, fetcher);

  return {
    data,
    isLoading: !data && !error,
    refresh: mutate,
    error,
    isValidating,
  };
}

export function useDataInfinite<T>(
  getKey: (pageIndex: number, previousPageData: T | null) => string | null,
  options?: {
    revalidateFirstPage?: boolean;
  }
) {
  const { data, error, mutate, isValidating, size, setSize } =
    useSWRInfinite<T>(getKey, fetcher, {
      revalidateFirstPage: options?.revalidateFirstPage,
    });

  return {
    data,
    isLoading: !data && !error,
    refresh: mutate,
    error,
    isValidating,
    size,
    setSize,
  };
}
